import * as Phaser from "phaser";
import { TavernScene } from "./tavern/tavern_scene.js";

function boot() {
  const mount = document.getElementById("tavern-canvas");
  const dialogue = document.getElementById("tavern-dialogue");
  const hud = document.getElementById("tavern-hud");
  if (!mount || !dialogue) return;

  let progress = {};
  try {
    const json = mount.dataset.progress;
    if (json) progress = JSON.parse(json);
  } catch (_e) { progress = {}; }

  let assets = {};
  try {
    const json = mount.dataset.assets;
    if (json) assets = JSON.parse(json);
  } catch (_e) { assets = {}; }

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: mount,
    backgroundColor: "#0d0d14",
    pixelArt: true,
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: window.innerWidth,
      height: window.innerHeight,
    },
    input: {
      activePointers: 2,
    },
    scene: [TavernScene],
    banner: false,
  });

  game.scene.start("Tavern", { progress, assets, dialogueRoot: dialogue, hudRoot: hud });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
